import dayjsLib from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

// Add any plugins you want globally
dayjsLib.extend(customParseFormat);

function safeDayjs(input, format, strict) {
  if (typeof input === "string") {
    // Remove trailing "Z" or "+HH:mm" timezone offsets
    input = input.replace(/Z$/, "").replace(/\+\d{2}:\d{2}$/, "");
  }
  return dayjsLib(input, format, strict);
}

// Keep all original Day.js methods on the wrapper
Object.assign(safeDayjs, dayjsLib);

export default safeDayjs;
